export type AppTheme = 'dark' | 'light'

const KEY = 'risen_app_theme'

export function currentTheme(): AppTheme {
  if (typeof window === 'undefined') return 'dark'
  return window.localStorage.getItem(KEY) === 'light' ? 'light' : 'dark'
}

export function applyTheme(theme: AppTheme): void {
  document.documentElement.dataset.theme = theme
  document.documentElement.style.colorScheme = theme
  window.localStorage.setItem(KEY, theme)
}
